import React from "react";

function UserAgreementText() {
  return (
    <div style={{ maxHeight: "40rem" }} className="lms-scrollbar d-flex flex-column px-10">
      <span className="h5 w-100 text-center">
        KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ HAKKINDA AYDINLATMA METNİ
      </span>
      <span className="mt-4">
        6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) hükümleri gereği kimliğinizi belirli
        veya belirlenebilir kılan her türlü bilginiz, özel nitelikli kişisel verileriniz de dahil
        olmak üzere, Kişisel ve Özel Nitelikte Veri olarak aşağıdaki kapsamda, Veri Sorumlusu
        sıfatıyla SINAV BASIN YAYIN DAĞITIM ORG.SAN.VE TİC.A.Ş tarafından işlenmektedir.
      </span>

      <span className="mt-4">
        “Kişisel Verilerinizin işlenmesi” kavramı yasal bir kavram olup, 6698 Sayılı Yasada bu
        kavram; kişisel verilerin elde edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi,
        değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması, devralınması, elde
        edilebilir hale getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi gibi
        veriler üzerinde gerçekleştirilen her türlü işlemi ifade etmektedir. Şirketimiz ile Öğrenci,
        Ürün veya Hizmet Alan Kişi, Tedarikçi Yetkilisi, Tedarikçi Çalışanı, Potansiyel Ürün veya
        Hizmet Alıcısı, Çalışan, Ziyaretçi, Çalışan Adayı, Hissedar/Ortak, Veli / Vasi / Temsilci,
        Sınav Adayı sıfat/ları ile paylaştığınız kişisel verileriniz KVKK’ya uygun şekilde, faaliyet
        ve hizmet amaçlarımız ile bağlantılı ve ölçülü olarak işlenebilecek, yurt içi ve yurt
        dışındaki üçüncü kişilere aktarılabilecek, saklanacak, profilleme veya başkaca işimizle
        ilgili ticari amaçlar için kullanılabilecek ve sınıflandırılabilecektir.
      </span>
      <span className="mt-4">
        SINAV BASIN YAYIN DAĞITIM ORG.SAN.VE TİC.A.Ş olarak kişisel verilerinizin güvenliğine en üst
        düzeyde önem veriyor, sizlere sunduğumuz tüm ürün ve hizmetlerimizde kişisel verilerinizin
        hukuka uygun olarak toplanması, saklanması, işlenmesi, gerekmesi durumunda paylaşılması
        sırasında gizliliğinizi korumak amacıyla mümkün olan en üst seviyede güvenlik tedbirlerini
        alıyoruz. Bu bilgilendirme/aydınlatma metnini yayınlamaktaki amacımız; sizlerin memnuniyeti
        doğrultusunda, kişisel verilerinizin toplanma şekilleri, işlenme amaçları, işlemenin hukuki
        nedenleri ve yasal haklarınız konularında sizleri en açık şekilde bilgilendirmektir. Aşağıda
        kişisel verilerin korunması ve işlenmesi konusunda önem taşıyan bilgiler ve kavramlar yer
        almakta olup bu kavramlar ile aydınlanmanızın tam olarak gerçekleşmesi hedeflenmektedir.
      </span>
      <span className="h6 mt-6">1. Veri Sorumlusunun Kimliği</span>
      <span className="mt-4">
        6698 sayılı Kişisel Verilerin Korunması Kanunu (6698 sayılı Kanun) uyarınca veri sorumlusu:
        SINAV BASIN YAYIN DAĞITIM ORG.SAN.VE TİC.A.Ş Kişisel verileriniz, veri sorumlusu olan SINAV
        BASIN YAYIN DAĞITIM ORG.SAN.VE TİC.A.Ş tarafından aşağıda açıklanan kapsamda toplanacak ve
        işlenebilecektir.
      </span>
      <span className="h6 mt-6">2. Kişisel Verilerin İşlenme Amacı</span>
      <span className="mt-4">
        Kişisel verileriniz, Kanun’a uygun olarak, Veri Sorumlusu tarafından sağlanan hizmet ve Veri
        Sorumlusu’nun ticari faaliyetlerine bağlı olarak değişkenlik gösterebilmekle birlikte;
        otomatik ya da otomatik olmayan yollarla, sözlü, yazılı ya da elektronik olarak
        toplanabilecektir. Kanun’un 5. ve 6. Maddelerinde belirtilen şartlara ve ilgili tüm mevzuata
        uygun olarak, Veri Sorumlusu tarafından;
      </span>
      <ul className="mt-2">
        <li>Eğitim Faaliyetlerinin Yürütülmesi</li>
        <li>İletişim Faaliyetlerinin Yürütülmesi</li>
        <li>Sınav Başvurularının Alınması</li>
        <li>Sınavın Gerçekleştirilmesi</li>
        <li>Mal / Hizmet Üretim Ve Operasyon Süreçlerinin Yürütülmesi</li>
        <li>Finans Ve Muhasebe İşlerinin Yürütülmesi</li>
        <li>Mal / Hizmet Satın Alım Süreçlerinin Yürütülmesi</li>
        <li>Mal / Hizmet Satış Sonrası Destek Hizmetlerinin Yürütülmesi</li>
        <li>Mal / Hizmet Satış Süreçlerinin Yürütülmesi</li>
        <li>İş Faaliyetlerinin Yürütülmesi / Denetimi</li>
        <li>Ölçme ve Değerlendirme Faaliyetlerinin Yürütülmesi</li>
        <li>Organizasyon Ve Etkinlik Yönetimi</li>
        <li>Sosyal Sorumluluk Ve Sivil Toplum Aktivitelerinin Yürütülmesi</li>
        <li>Acil Durum Yönetimi Süreçlerinin Yürütülmesi</li>
        <li>Çalışanlar İçin Yan Haklar Ve Menfaatleri Süreçlerinin Yürütülmesi</li>
        <li>Taşınır Mal Ve Kaynakların Güvenliğinin Temini</li>
        <li>Yönetim Faaliyetlerinin Yürütülmesi</li>
        <li>Bilgi Teknolojisi Faaliyetlerinin Yürütülmesi</li>
        <li>Diğer-İdareye Ait Malların Kaydı Muhafazası ve Kullanımı</li>
        <li>Denetim / Etik Faaliyetlerinin Yürütülmesi</li>
        <li>Fiziksel Mekan Güvenliğinin Temini</li>
        <li>Hukuk İşlerinin Takibi Ve Yürütülmesi</li>
        <li>İç Denetim/ Soruşturma / İstihbarat Faaliyetlerinin Yürütülmesi</li>
        <li>İş Sağlığı / Güvenliği Faaliyetlerinin Yürütülmesi</li>
        <li>Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi</li>
        <li>Talep / Şikayetlerin Takibi</li>
        <li>Veri Sorumlusu Operasyonlarının Güvenliğinin Temini</li>
        <li>Ziyaretçi Kayıtlarının Oluşturulması ve Takibi</li>
        <li>Faaliyetlerin Mevzuata Uygun Yürütülmesi</li>
        <li>Çalışan Adayı / Stajyer / Öğrenci Seçme Ve Yerleştirme Süreçlerinin Yürütülmesi</li>
        <li>Yetkili Kişi, Kurum Ve Kuruluşlara Bilgi Verilmesi</li>
        <li>Bilgi Güvenliği Süreçlerinin Yürütülmesi</li>
        <li>Erişim Yetkilerinin Yürütülmesi</li>
        <li>Görevlendirme Süreçlerinin Yürütülmesi</li>
        <li>İnsan Kaynakları Süreçlerinin Planlanması</li>
        <li>İş Süreçlerinin İyileştirilmesine Yönelik Önerilerin Alınması Ve Değerlendirilmesi</li>
        <li>Çalışanlar İçin İş Akdi Ve Mevzuattan Kaynaklı Yükümlülüklerin Yerine Getirilmesi</li>
        <li>Çalışan Adaylarının Başvuru Süreçlerinin Yürütülmesi</li>
        <li>Sözleşme Süreçlerinin Yürütülmesi</li>
        <li>
          İş Sürekliliğinin Sağlanması Faaliyetlerinin Yürütülmesi amaçlarıyla işlenebilecektir.
        </li>
      </ul>
      <span className="mt-4 font-weight-bolder">
        Kişisel verilerin işlenmesinde aşağıdaki ilkelere uyulmaktadır:{" "}
      </span>
      <span className="mt-2">Hukuka ve dürüstlük kurallarına uygunluk,</span>
      <span className="mt-2">Doğru ve gerektiğinde güncel olma,</span>
      <span className="mt-2">Belirli, açık ve meşru amaçlar için işlenme,</span>
      <span className="mt-2">İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü olma,</span>
      <span className="mt-2">
        İlgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza
        edilme.
      </span>
      <span className="h6 mt-6">3. Kişisel Verilerin Aktarılması</span>
      <span className="mt-4">
        Kişisel verileriniz; ilgili mevzuat sınırları dahilinde, yukarıda belirtilen amaçların
        gerçekleştirilmesi ve mevzuatın getirdiği yükümlülüklerin yerine getirilmesi ile sınırlı
        olmak üzere 6698 sayılı Kanun’un kişisel verilerin aktarılmasına ilişkin 8. maddesi ve
        kişisel verilerin yurt dışına aktarılmasına ilişkin 9. maddesinde belirtilen kişisel veri
        işleme şartları ve amaçları çerçevesinde aktarılabilecektir. Yurtiçinde İlgili Kişi için
        Hizmet Sunumu, Yasal Yükümlülük, Ticari Amaç, Operasyonel İşlemler, İdare Talebi, Sözleşme,
        Mahkeme Emri sebeplerine dayanılarak belirli gruplara aktarılabilecektir.Yurtiçi alıcı
        grupları; gerçek kişiler veya özel hukuk tüzel kişileri, tedarikçiler, yetkili kamu kurum ve
        kuruluşları, iştirakler ve bağlı ortaklıklar, diğer-banka. Yurtdışına aktarım
        yapılmamaktadır.
      </span>
      <span className="h6 mt-6">4. Kişisel Verilerin Toplama Yöntemi ve Hukuki Sebebi</span>
      <span className="mt-4">
        Tarafınıza ait kişisel veriler, KVKK ve diğer ilgili mevzuatlara ve SINAV BASIN YAYIN
        DAĞITIM ORG.SAN.VE TİC.A.Ş Kişisel Verilerin Korunması ve İşlenmesi Politikasına uygun
        olarak şirketin yukarıda belirtilen amaçların gerçekleştirilmesi için aşağıda belirtilen
        toplama yöntemleri kullanılarak toplanmakta ve işlenmektedir.
      </span>
      <span className="mt-2">
        El yazısı
        <br />
        Kağıt
        <br />
        Web Tabanlı Yazılım
        <br />
        Yazılım Programı
        <br />
        myexamy Yazılım Sistemi
        <br />
        Fotoğraf Makinesi-Kamera
        <br />
        Bilgi Teknolojileri Veri Kayıt Sistemi
        <br />
        Excel Programı
        <br />
        Muhasebe Programı
        <br />
      </span>
      <span className="mt-2">
        Yukarıda belirtilen işleme yöntemleri ile sözlü, yazılı ya da elektronik olarak toplanan
        Kişisel Verileriniz KVKK m. 5 ve 6. Hükümlerine uygun olarak; Hukuki Yükümlülüğün Yerine
        Getirilmesi, Kanunlarda Öngörülmesi, Bir hakkın Tesisi, Kullanılması veya Korunması, Açık
        Rızanın Alınması, Veri Sorumlusunun Meşru Menfaatleri, Sözleşme İmzalanması hukuki
        sebeplerine dayanılarak işlenmektedir. Sayılan bu yöntemlerle toplanan ve işlenen kişisel
        verileriniz 6698 sayılı Kanun’un 5. ve 6. maddelerinde belirtilen kişisel veri işleme
        şartları ve amaçları kapsamında bu Bilgilendirmede belirtilen amaçlarla işlenebilmekte ve
        aktarılabilmektedir.
      </span>
      <span className="h6 mt-6">
        5. 6698 sayılı Kanun’un 11. maddesindeki düzenlemeye göre Kişisel Veri Sahibi olarak 11.
        Maddede Sayılan Haklarınız
      </span>
      <span className="mt-4 pl-6">
        Kişisel verilerinizin işlenip işlenmediğini öğrenme,
        <br />
        Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
        <br />
        Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
        öğrenme,
        <br />
        Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
        <br />
        Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini
        isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere
        bildirilmesini isteme,
        <br />
        6698 sayılı Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen,
        işlenmesini gerektiren sebeplerin ortadan kalkması halinde kişisel verilerinizin silinmesini
        veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı
        üçüncü kişilere bildirilmesini isteme,
        <br />
        İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
        aleyhine bir sonucun ortaya çıktığını düşünüyorsanız buna itiraz etme,
        <br />
        Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde
        zararınızın giderilmesini talep etmedir.
      </span>
      <span className="mt-4">
        Haklarınıza ilişkin taleplerinizi aşağıda belirttiğimiz yöntemlerle şirketimize iletmeniz
        durumunda şirketimiz, niteliğine göre talebi en kısa sürede ve en geç otuz gün içinde
        ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyet doğurması halinde,
        şirketimiz tarafından Kişisel Verileri Koruma Kurulu’nca belirlenen tarifedeki ücret
        alınacaktır. Bu kapsamda 6698 sayılı Kanun’un 13. maddesinin 1. fıkrası gereğince, yukarıda
        belirtilen haklarınızı kullanmak ile ilgili talebinizi, yazılı olarak ve Kişisel Verileri
        Koruma Kurulu’nun belirleyeceği diğer yöntemlerle şirketimize iletebilirsiniz. Bu çerçevede
        şirketimize 6698 sayılı Kanun’un 11. maddesi kapsamında yapacağınız başvurularda yazılı
        olarak başvurunuzu ileteceğiniz kanallar ve usuller aşağıda açıklanmaktadır. Yukarıda
        belirtilen haklarınızı kullanmak için, sinav.com.tr adresinde bir örneği bulunan ilgili
        kişi/veri sahibi başvuru/talep formu’nu doldurup imzaladıktan sonra bu başvuru formunu ya da
        haklarınızı kullanmak için düzenlediğiniz orijinal imzalı dilekçenizi; Şirketimizin OSTİM
        OSB MAHALLESİ 1249 CADDE NO: 5, YENİMAHALLE ANKARA adresi sekretaryasına kimliğinizi tespit
        edici belgeler ile elden teslim edebilir, Noter vasıtasıyla veya iadeli taahhütlü posta
        yoluyla yukarıdaki adresimize gönderebilir, sinav@hs01.kep.tr adresine kep adresiniz varsa
        güvenli elektronik imzalı olarak iletebilirsiniz. Aydınlatma metnini okuduğunuz için
        teşekkür ederiz.
      </span>
      <span className="mt-4 font-weight-bolder">SINAV BASIN YAYIN DAĞITIM ORG.SAN.VE TİC.A.Ş</span>
    </div>
  );
}

export default UserAgreementText;
